import { Badge, type BadgeTone } from "./Badge.js";

type Status = "booked" | "cancelled" | "pending_calendar_sync";
type Modality = "in-person" | "video";
type PatientType = "new" | "existing";

const STATUS_LABEL: Record<Status, string> = {
  booked: "Booked",
  cancelled: "Cancelled",
  pending_calendar_sync: "Pending sync",
};

const STATUS_TONE: Record<Status, BadgeTone> = {
  booked: "emerald",
  cancelled: "rose",
  pending_calendar_sync: "amber",
};

export function StatusBadge({ status }: { status: Status }) {
  return <Badge tone={STATUS_TONE[status]}>{STATUS_LABEL[status]}</Badge>;
}

export function ModalityBadge({ value }: { value: Modality }) {
  return (
    <Badge tone="blue">{value === "video" ? "Video" : "In-person"}</Badge>
  );
}

export function PatientTypeBadge({ value }: { value: PatientType }) {
  return (
    <Badge tone={value === "new" ? "emerald" : "slate"}>
      {value === "new" ? "New" : "Existing"}
    </Badge>
  );
}
